import { render, staticRenderFns } from "./couponRecordLists.vue?vue&type=template&id=1eda0232&scoped=true&"
import script from "./couponRecordLists.vue?vue&type=script&lang=js&"
export * from "./couponRecordLists.vue?vue&type=script&lang=js&"
import style0 from "./couponRecordLists.vue?vue&type=style&index=0&id=1eda0232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda0232",
  null
  
)

export default component.exports